import { createContext, ReactNode, useState, useRef } from "react";

interface dialogContextType {
  isDialogOpen: boolean;
  setIsDialogOpen: (open: boolean) => void;
  handleOpenDialog: () => void;
  handleCloseDialog: () => void;
}

export const DialogContext = createContext<dialogContextType>({
  isDialogOpen: false,
  setIsDialogOpen: () => {},
  handleOpenDialog: () => {},
  handleCloseDialog: () => {},
});

export default function DialogContextProvider({ children }: { children: ReactNode }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const lastFocusedElement = useRef<HTMLElement | null>(null);

  function resetAnyPreviousFocus() {
    if (document.activeElement instanceof HTMLElement) {
      lastFocusedElement.current = document.activeElement;
      document.activeElement.blur();
    }
  }

  function handleOpenDialog() {
    resetAnyPreviousFocus();
    setIsDialogOpen(true);
  }

  function handleCloseDialog() {
    setIsDialogOpen(false);
  }

  const values: dialogContextType = {
    isDialogOpen,
    setIsDialogOpen,
    handleCloseDialog,
    handleOpenDialog,
  };

  return <DialogContext.Provider value={values}>{children}</DialogContext.Provider>;
}
